function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import StarRatings from 'react-star-ratings';
import { withTheme } from 'styled-components';
var svgTypes = [{
  type: 'star',
  path: 'M15 0.333344C15.5075 0.333344 15.9709 0.62144 16.1956 1.07651L20.0056 8.7953L28.5261 10.0407C29.0282 10.1141 29.4451 10.4661 29.6016 10.9488C29.7581 11.4314 29.6271 11.9611 29.2636 12.3152L23.0993 18.3192L24.5541 26.8013C24.6399 27.3015 24.4342 27.8071 24.0236 28.1054C23.613 28.4037 23.0686 28.443 22.6194 28.2068L15 24.1998L7.38056 28.2068C6.93134 28.443 6.38695 28.4037 5.97631 28.1054C5.56567 27.8071 5.36001 27.3015 5.44581 26.8013L6.9006 18.3192L0.736314 12.3152C0.372823 11.9611 0.241792 11.4314 0.398296 10.9488C0.5548 10.4661 0.971706 10.1141 1.47379 10.0407L9.99428 8.7953L13.8043 1.07651C14.029 0.62144 14.4925 0.333344 15 0.333344Z',
  viewBox: '0 0 30 29',
  starSpacing: '2.67px'
}, {
  type: 'circle',
  path: 'M25,100a75,75 0 1,0 150,0a75,75 0 1,0 -150,0',
  viewBox: '0 0 220 220'
}, {
  type: 'feature',
  path: 'M25,100a75,75 0 1,0 150,0a75,75 0 1,0 -150,0',
  viewBox: '0 0 175 175'
}, {
  type: 'infoStar',
  path: 'M7.99998 0.666656C8.25372 0.666656 8.48547 0.810705 8.59778 1.03824L10.5028 4.89763L14.7631 5.52033C15.0141 5.55703 15.2226 5.73303 15.3008 5.97437C15.3791 6.21571 15.3135 6.48054 15.1318 6.65756L12.0497 9.65957L12.7771 13.9006C12.8199 14.1508 12.7171 14.4035 12.5118 14.5527C12.3065 14.7018 12.0343 14.7215 11.8097 14.6034L7.99998 12.5999L4.19028 14.6034C3.96567 14.7215 3.69347 14.7018 3.48816 14.5527C3.28284 14.4035 3.18001 14.1508 3.22291 13.9006L3.9503 9.65957L0.868157 6.65756C0.686411 6.48054 0.620896 6.21571 0.699148 5.97437C0.7774 5.73303 0.985853 5.55703 1.23689 5.52033L5.49714 4.89763L7.40217 1.03824C7.51449 0.810705 7.74623 0.666656 7.99998 0.666656Z',
  viewBox: '0 0 16 16',
  starSpacing: '0px'
}];
var Rating = function (_React$Component) {
  _inherits(Rating, _React$Component);
  var _super = _createSuper(Rating);
  function Rating() {
    var _this;
    _classCallCheck(this, Rating);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      value: _this.props.value
    });
    _defineProperty(_assertThisInitialized(_this), "handleRatingChange", function (rating) {
      _this.setState({
        value: rating
      });
      if (typeof _this.props.onChange === 'function') {
        _this.props.onChange(rating);
      }
    });
    return _this;
  }
  _createClass(Rating, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var svg = svgTypes.find(function (el) {
        return el.type === _this2.props.type;
      });
      var starColor = this.props.starColor;
      var starEmptyColor = this.props.starEmptyColor;
      var starSpacing = '1px';
      switch (this.props.type) {
        case 'star':
          starColor = this.props.theme.ratingStarColor;
          starEmptyColor = this.props.theme.ratingStarEmptyColor;
          starSpacing = '1px';
          break;
        case 'infoStar':
          starColor = this.props.theme.ratingStarColor;
          starEmptyColor = this.props.theme.ratingStarEmptyColor;
          starSpacing = svg.starSpacing;
          break;
        case 'circle':
        case 'feature':
          starColor = 'rgb(23, 133, 251)';
          starEmptyColor = '#D1D8E2';
          starSpacing = '0px';
          break;
        default:
          starColor = this.props.theme.ratingStarEmptyColor;
          starEmptyColor = this.props.theme.ratingStarEmptyColor;
      }
      return React.createElement(StarRatings, {
        rating: this.state.value,
        starEmptyColor: starEmptyColor,
        starRatedColor: starColor,
        starHoverColor: starColor,
        numberOfStars: this.props.max,
        starDimension: this.props.starSize,
        starSpacing: starSpacing,
        name: "rating",
        changeRating: this.props.isSelectable ? this.handleRatingChange : null,
        isSelectable: this.props.isSelectable,
        svgIconPath: svg ? svg.path : '',
        svgIconViewBox: svg ? svg.viewBox : ''
      });
    }
  }]);
  return Rating;
}(React.Component);
_defineProperty(Rating, "defaultProps", {
  type: 'star',
  isSelectable: true,
  max: 5,
  starSize: '20px',
  starColor: '#FFD552',
  starColorHover: '#FFD552',
  starEmptyColor: '#D1D8E2',
  onChange: function onChange() {}
});
export default withTheme(Rating);